import React, { useEffect, useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import '../styles/PcMenu.css';

const PcMenu = ({ closeMenu }) => {
    // Accept closeMenu as a prop { closeMenu}
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAuthenticated(!!user);
        });

        return () => unsubscribe();
    }, []);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownRef]);

    return (
        <ul className="pc-menu">
            {!isAuthenticated && (
                <li>
                    <NavLink
                        exact="true"
                        to="/"
                        className={({ isActive }) => (isActive ? "active-link" : undefined)}
                        onClick={closeMenu} // Close menu on click
                    >
                        Home
                    </NavLink>
                </li>
            )}

            <li>
                <NavLink
                    to="/about-us"
                    className={({ isActive }) => (isActive ? "active-link" : undefined)}
                    onClick={closeMenu}
                >
                    About Us
                </NavLink>
            </li>
            <li>
                <NavLink
                    to="/contact-us"
                    className={({ isActive }) => (isActive ? "active-link" : undefined)}
                    onClick={closeMenu}
                >
                    Contact Us
                </NavLink>
            </li>
            {!isAuthenticated && (
                <>
                    <li>
                        <NavLink
                            to="/loans"
                            className={({ isActive }) => (isActive ? "active-link" : undefined)}
                            onClick={closeMenu}
                        >
                            Loans
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/services"
                            className={({ isActive }) => (isActive ? "active-link" : undefined)}
                            onClick={closeMenu}
                        >
                            Corporate Services
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/login"
                            className={({ isActive }) => (isActive ? "active-link" : undefined)}
                            onClick={closeMenu}
                        >
                            My Account
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/terms"
                            className={({ isActive }) => (isActive ? "active-link" : undefined)}
                            onClick={closeMenu}
                        >
                            Terms & Condition
                        </NavLink>
                    </li>
                </>
            )}
        </ul>
    );
};

export default PcMenu;
